import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';

const ALL = '__all__';

export interface FilterOption<T extends string> {
  value: T;
  label: string;
}

/**
 * One value per field: the server ANDs every filter and ignores `logic`, so "fiat OR crypto"
 * can't be expressed and multi-select would silently return nothing.
 */
export function DataTableSelectFilter<T extends string>({
  label,
  value,
  options,
  onChange,
  allLabel = 'All',
  className,
}: {
  label: string;
  value: T | undefined;
  options: readonly FilterOption<T>[];
  onChange: (value: T | undefined) => void;
  allLabel?: string;
  className?: string;
}) {
  const current = options.find((o) => o.value === value);
  return (
    <Select value={current ? current.value : ALL} onValueChange={(v) => onChange(v === ALL ? undefined : (v as T))}>
      <SelectTrigger size="sm" aria-label={label} className={cn('min-w-32', current && 'border-primary/50', className)}>
        <span className="text-muted-foreground">{label}:</span>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>{allLabel}</SelectItem>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
